<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="How To Choose Your French Oven">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e284" xmlns:saxon="http://icl.com/saxon">How To
              Choose Your French Oven </a></h1><a id="d0e284" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e284" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e284" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e284" xmlns:saxon="http://icl.com/saxon">
<p>One of the first things to consider when purchasing a French oven is weight. If it will be
        difficult for you to lift an enameled cast iron French oven filled with food from the stove
        to the oven and back again then you might want to pick one of the lighter ovens made from
        ceramics or copper. </p>
<p>Although enameled cast iron French ovens are lighter now than they used to be, they are
        still sturdy and safe on the stove, not likely to be knocked over when you are deep-frying
        or have a stew bubbling away. I keep one on the back burner and value its weight for this
        reason. </p>
<p>Also consider the size of the handles. Some are smaller and some are larger so that you can
        fit oven mitts into them.</p>
<p>If you have an induction stovetop, check to see if your French oven can be used on it. Most
        of them can. </p>
<p>And now that they come in so many colors, it is possible to find white French ovens to go
        with a white kitchen, modern colors to go with a modern kitchen, and earthy colors to fit
        into a rustic look. Some of the French manufacturers are even dreaming up seasonal colors
        that fit a spring, summer, fall, or winter decor or menu. For the mini cocottes, there is a
        rainbow of colors and materials to choose from. I even have a set of pearlized white and
        black ones that I use for New Year’s Eve. </p>
<div class="mediaobject" title="Photo of flowers.">
<img alt="Photo of flowers." src="images/IMG_3086.jpg"/>
</div>
</a></div><a id="d0e284" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?4f8f17a2